import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	share: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.shared',
		defaultMessage: '{name} shared',
		description: 'Used in the trigger that shows the social signal for the user',
	},
	edit: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.edited',
		defaultMessage: '{name} edited',
		description: 'Used in the trigger that shows the social signal for the user',
	},
	comment: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.commented',
		defaultMessage: '{name} commented',
		description: 'Used in the trigger that shows the social signal for the user',
	},
});
